import { postFormData, post, get, del } from '../index'


export const createOffer = post('/employee/offer')
export const sendMessage = post('/employee/chat')
export const getSessionStatus = get('/employee/session/stats')
export const closeTalkSession = del('/employee/session/close')